import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/Blocks";
import { CtaBand } from "@/components/site/Cta";
import { Icon } from "@/components/site/Icon";
import { SERVICES } from "@/data/services";

export default function ServicesIndex() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Servizi", to: "/servizi" }];
  return (
    <>
      <Seo path="/servizi" title="Servizi: siti web, cataloghi, e-commerce, CRM e social | STUDIO WEB NS"
        description="Tutti i servizi di STUDIO WEB NS: realizzazione e rifacimento siti, manutenzione, cataloghi digitali, e-commerce, CRM, gestione social e SEO. In tutta Italia." jsonLd={crumbsLd(crumbs)} />
      <PageHero crumbs={crumbs} eyebrow="Servizi" title="La tua presenza digitale, sempre aggiornata." intro="Dalla prima pagina online alla gestione continuativa: scegli il servizio che ti serve oggi, aggiungi gli altri quando servono." />
      <section className="py-14 md:py-20">
        <div className="wrap grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/servizi/${s.slug}`} data-testid={`services-card-${s.slug}`} className="card group flex flex-col p-8 transition-[border-color,box-shadow,transform] hover:-translate-y-1 hover:border-slate-900 hover:shadow-[0_24px_50px_-30px_rgba(15,23,42,0.35)]">
              <div className="flex items-start justify-between">
                <Icon name={s.icon} className="h-6 w-6 text-blue-600" strokeWidth={1.6} />
                <ArrowUpRight className="h-5 w-5 text-slate-300 transition-colors group-hover:text-blue-600" />
              </div>
              <h2 className="mt-8 font-display text-xl font-bold">{s.name}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.short}</p>
            </Link>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
